import getFetchStatusSelectors from './'


export default getFetchStatusSelectors('byCustomerId')
